/** Connector debug row builders for hierarchy visualization. */
/** Max title characters in connector debug rows. */
export const CONNECTOR_DEBUG_TITLE_PREVIEW_LENGTH = 36;

/**
 * @param {import('@/types').Task[]} tasks
 * @param {number} index
 * @param {number} displayLevel
 * @param {object} options
 * @returns {{ isFirst: boolean, isLast: boolean }}
 */
export function getSiblingConnectorFlags(tasks, index, displayLevel, options) {
  if (displayLevel <= 0) {
    return { isFirst: false, isLast: false };
  }

  const {
    indentationType,
    isExecutionView,
    isFirstSiblingInFlatList,
    isLastSiblingInFlatList,
  } = options;
  return {
    isFirst: isFirstSiblingInFlatList(
      tasks,
      index,
      displayLevel,
      indentationType,
      isExecutionView,
    ),
    isLast: isLastSiblingInFlatList(
      tasks,
      index,
      displayLevel,
      indentationType,
      isExecutionView,
    ),
  };
}

/** @param {number} displayLevel @param {boolean} isFirst @param {boolean} isLast */
export function formatConnectorLabel(displayLevel, isFirst, isLast) {
  if (displayLevel === 0) {
    return 'none (level 0)';
  }

  const firstPart = isFirst ? 'first' : '';
  const middlePart = isFirst && isLast ? '+' : '';
  const lastPart = isLast ? 'last' : '';
  return `${firstPart}${middlePart}${lastPart}`;
}

/**
 * @param {import('@/types').Task} task
 * @param {number} index
 * @param {import('@/types').Task[]} tasks
 * @param {object} options
 */
export function buildConnectorDebugRow(task, index, tasks, options) {
  const displayLevel = options.listDisplayLevel(task);
  const { isFirst, isLast } = getSiblingConnectorFlags(
    tasks,
    index,
    displayLevel,
    options,
  );

  return {
    index,
    id: task.id,
    title: (task.title ?? '').slice(0, CONNECTOR_DEBUG_TITLE_PREVIEW_LENGTH),
    completed: task.completed ?? false,
    status: task.status ?? '',
    displayLevel,
    connector: formatConnectorLabel(displayLevel, isFirst, isLast),
    path: task.materializedPath ?? '',
  };
}
